import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { RouteSkeleton } from '../RouteSkeleton';
/**
 * Accepts an optional RedirectPath value. This helper component is meant to be used in conjunction with the useRedirectPath hook.
 * It also allows for a fallback component to be displayed when the redirectPath calculation is still processing.
 *
 * @param redirectPath
 * @param fallback
 * @constructor
 */
export var AllyRedirect = function (_a) {
    var redirectPath = _a.redirectPath, _b = _a.fallback, fallback = _b === void 0 ? React.createElement(RouteSkeleton, null) : _b;
    useEffect(function () {
        if (redirectPath.state === 'RedirectExternal') {
            window.location.href = redirectPath.route;
        }
    }, [redirectPath]);
    if (redirectPath.state === 'RedirectInternal') {
        return React.createElement(Redirect, { to: redirectPath.route, push: true });
    }
    return React.createElement(React.Fragment, null, fallback);
};
//# sourceMappingURL=AllyRedirect.js.map